/*=========================================================================================
  File Name: moduleEcommerceMutations.js
  Description: Ecommerce Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import _ from 'lodash';

export default {
  TOGGLE_ITEM_IN_WISH_LIST(state, item) {
    const index = state.wishList.findIndex(i => i.objectID == item.objectID)
    if (index < 0) {
      state.wishList.push(item)
    } else {
      state.wishList.splice(index, 1)
    }
  },
  FLUSH_COUPON(state) {
    state.hasCoupon = false;
    state.coupon = undefined;
    for (let i in state.cartItems) {
      state.cartItems[i].coupon = undefined;
      state.cartItems[i].couponType = undefined;
      state.cartItems[i].promoDiscount = undefined;
    }
  },
  TOGGLE_ITEM_IN_CART(state, item) {
    const index = state.cartItems.findIndex(i => i.id == item.id)
    if (index < 0) {
      state.cartItems.push(item)
    } else {
      state.cartItems.splice(index, 1)
    }
    let exp = state.cartItems.map((item) => {
      return {qty: item.qty, pid: item.id, vid: item.v.id};
    });
    localStorage.setItem('cart_items', JSON.stringify(exp));
  },
  ADD_ITEM_IN_CART(state, item) {
    item.price = _.get(item, 'variants.0.price');
    state.cartItems.push(item)
  },
  SET_ADDRESS(state, item) {
    if (item.zip) {
      let isWest = 10000 <= item.zip && item.zip <= 86900;
      let isEast = 87000 <= item.zip && item.zip <= 98859;
      let total = state.total - state.discount - state.proDiscount;
      if (isWest && total < 131) {
        state.shippingCost = 8;
      } else if (isWest && total > 130) {
        state.shippingCost = 0;
      } else if (isEast && total < 351) {
        state.shippingCost = 27;
      } else if (isEast && total > 350) {
        state.shippingCost = 0;
      } else if (!(isWest || isEast)) {
        state.shippingCost = -1;
      } else {
        state.shippingCost = undefined;
      }
    }
    state.address = item;
  },
  CALC_COUPON(state, payload) {
    if (payload) {
      for (let i in state.cartItems) {
        if (payload.prc.some((ii) => ii.id === state.cartItems[i].id) || payload.prc[0] === '*') {
          state.cartItems[i].coupon = _.get(payload, 'coupon.price_rule.value');
          state.cartItems[i].couponType = _.get(payload, 'coupon.price_rule.value_type');
          const it = state.cartItems[i];
          if (it.coupon) {
            switch (it.couponType) {
              case 1:
                state.cartItems[i].promoDiscount = ((state.cartItems[i].coupon / 100) * (it.v.original_price * (it.qty || 1)));
                break;
              case 2:
                state.cartItems[i].promoDiscount = state.cartItems[i].coupon * it.qty;
                break;
            }
          }
        }
      }
      state.hasCoupon = true;
      state.coupon = payload.coupon;
    } else {
      state.hasCoupon = false;
    }
    state.forceUp = !state.forceUp;
  },
  UPDATE_ITEM_QUANTITY(state, payload) {
    const it = state.cartItems[payload.index];
    state.cartItems[payload.index].qty = payload.qty
    if (it.coupon) {
      switch (it.couponType) {
        case 1:
          state.cartItems[payload.index].promoDiscount = ((it.coupon / 100) * payload.oprice * payload.qty);
          break;
        case 2:
          state.cartItems[payload.index].promoDiscount = it.coupon * payload.qty;
          break;
      }
      state.cartItems[payload.index].price = payload.oprice * payload.qty;
    } else {
      state.cartItems[payload.index].price = payload.price * payload.qty;
    }
    let exp = state.cartItems.map((item) => {
      return {qty: item.qty, pid: item.id, vid: item.v.id};
    });
    localStorage.setItem('cart_items', JSON.stringify(exp));
  },
  SERVER_INIT(state) {
    state.syncServer = true;
  },
  INIT(state, data) {
    state.cartItems = data || [];
  },
  SET_TOTAL(state, data) {
    state.total = data || 0;
  },
  SET_DISCOUNT(state, data) {
    state.discount = data || 0;
  },
  SET_PRO_DISCOUNT(state, data) {
    state.proDiscount = data || 0;
  },
  FLUSH(state) {
    state.cartItems = [];
    localStorage.removeItem('cart_items');
  }
}
